import { render, staticRenderFns } from "./detailsMessageSendByLocal.vue?vue&type=template&id=4c743d4e&"
import script from "./detailsMessageSendByLocal.vue?vue&type=script&lang=js&"
export * from "./detailsMessageSendByLocal.vue?vue&type=script&lang=js&"
import style0 from "./detailsMessageSendByLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports